
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class EmojiInput extends Vue {
  get DataStore() {
    return this.$store.$genseeLive
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
